module.exports = __webpack_public_path__ + "img/area8-3.5776794.png";